import React from 'react'
import { Button } from 'antd'
import { CheckCircleFilled } from '@ant-design/icons'
import styles from './ContactVerificationBadge.module.scss'

interface IContactVerificationBadgeProps {
  isVerified: boolean
  isLoading?: boolean
  // Кнопка появляется только там, где открывшему есть чем подтвердить: свои
  // контакты или телефон администратора у супер-админа
  onConfirm?: () => void
}

export const ContactVerificationBadge: React.FC<
  IContactVerificationBadgeProps
> = ({ isVerified, isLoading, onConfirm }) => {
  if (isVerified) {
    return (
      <span className={styles.verified}>
        <CheckCircleFilled />
        Подтверждён
      </span>
    )
  }

  if (!onConfirm) {
    return <span className={styles.unverified}>Не подтверждён</span>
  }

  return (
    <Button
      type='link'
      size='small'
      className={styles.confirmButton}
      loading={isLoading}
      onClick={onConfirm}
    >
      Подтвердить
    </Button>
  )
}
